module.exports = __webpack_public_path__ + "images/external_images/svg/logos/logo-white.svg";